<template>
    <div class="text-center rounded p-4">
        <div class="text-2xl font-weight-bold">
            <slot/>
        </div>
        <div class="font-weight-light">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>
